// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-P0y","icon":"styles_icon__1KJiJ"};